// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__pW6Av","loaderOuter":"PageOverlayLoader_loaderOuter__375aI"};